// extracted by mini-css-extract-plugin
module.exports = {"container":"Psy8hj","title":"aPbCpd","textButton":"nnZUqa"};